import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { MaskReveal } from "../components/Motion";
import { IMAGES, CONTACT } from "../data/content";

const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "28%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  const textY = useTransform(scrollYProgress, [0, 1], ["0%", "-40%"]);
  const overlayOpacity = useTransform(scrollYProgress, [0, 1], [0.5, 0.9]);

  return (
    <section ref={ref} data-testid="hero-section" className="relative h-[100svh] w-full overflow-hidden">
      <motion.div style={{ y: imgY, scale }} className="absolute inset-0 will-change-transform">
        <img
          src={IMAGES.heroConcert}
          alt="RLP Photography — cinematic concert lighting"
          className="h-full w-full object-cover"
        />
        <motion.div style={{ opacity: overlayOpacity }} className="absolute inset-0 bg-black" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-[#050505]/60" />
      </motion.div>

      <motion.div style={{ y: textY }} className="relative z-10 h-full mx-auto max-w-[1600px] px-6 md:px-12 flex flex-col justify-end pb-[8vh]">
        <div className="mb-6 flex items-center gap-4">
          <MaskReveal delay={0.5}>
            <span className="text-xs uppercase tracking-[0.3em] text-[#F5A623] font-medium">
              {CONTACT.location} · Est. Studio
            </span>
          </MaskReveal>
        </div>

        <h1 className="font-serif font-medium text-white leading-[0.82] tracking-tighter text-[19vw] md:text-[15vw] lg:text-[13vw]">
          <MaskReveal delay={0.4}>Framing</MaskReveal>
          <MaskReveal delay={0.55} className="italic pl-[0.08em]">
            the <span className="text-stroke-accent">unseen</span>
          </MaskReveal>
        </h1>

        <div className="mt-8 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 1 }}
            className="max-w-md text-[#A1A1AA] text-base sm:text-lg leading-relaxed"
          >
            A San Antonio photography studio for corporate headshots, business
            branding, and the electric chaos of live concerts.
          </motion.p>

          <motion.button
            data-testid="hero-book-btn"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.9, delay: 1.2 }}
            onClick={() => document.getElementById("book")?.scrollIntoView({ behavior: "smooth" })}
            className="group flex items-center gap-4 self-start"
          >
            <span className="h-16 w-16 rounded-full border border-white/30 flex items-center justify-center group-hover:bg-white group-hover:text-black transition-colors duration-400">
              <ArrowDown size={22} />
            </span>
            <span className="uppercase tracking-[0.2em] text-sm text-white">Start a project</span>
          </motion.button>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
